<div class="sidebar-wrapper">
  <aside class="sidebar" id="sidebar">
    <div class="sidebar__menu-group">
      <nav class="menu">
        <ul class="sidebar_nav">
          <!-- DASHBOARD -->
          <li
            routerLink="dashboard"
            routerLinkActive="active"
            *appHasAnyRole="['DASHBOARD', 'visualizar_dashboard']"
          >
            <img src="icons/home-04.svg" alt="home Icon" />
            Dashboard
          </li>

          <!-- RELATÓRIOS -->
          <li
            routerLink="relatorios"
            routerLinkActive="active"
            *appHasAnyRole="[
              'RELATÓRIOS',
              'emitir_relatório_estudante',
              'emitir_relatório_profissionais'
            ]"
          >
            <img src="icons/report.svg" alt="report Icon" />
            Relatórios
          </li>

          <!-- PROFISSIONAIS DO SECTOR -->
          <li
            class="text-separator"
            (click)="toggleSubmenu('showSubmenuOne')"
            *appHasAnyRole="[
              'PROFISSIONAIS DO SECTOR',
              'visualizar_menu_profissionais',
              'visualizar_menu_vagas',
              'visualizar_menu_candidaturas',
              'visualizar_menu_empresas_sector'
            ]"
          >
            PROFISSIONAIS DO SECTOR
            <i
              class="pi pi-angle-down"
              [ngClass]="{ rotate: submenus.showSubmenuOne }"
            ></i>
          </li>
          <ul class="submenu" [ngClass]="{ open: submenus.showSubmenuOne }">
            <li
              routerLink="bolsa-profissionais/profissionais"
              routerLinkActive="active"
              *appHasAnyRole="[
                'PROFISSIONAIS',
                'visualizar_menu_profissionais'
              ]"
            >
              <img src="icons/users-01.svg" alt="Profissionais Icon" />
              Profissionais
            </li>
            <li
              routerLink="bolsa-profissionais/vagas"
              routerLinkActive="active"
              *appHasAnyRole="[
                'VAGAS',
                'visualizar_menu_vagas',
                'abrir_vagas_emprego',
                'vaga_create'
              ]"
            >
              <img src="icons/img-briefcase.svg" alt="Vagas Icon" />
              Vagas
            </li>
            <li
              routerLink="bolsa-profissionais/candidaturas"
              routerLinkActive="active"
              *appHasAnyRole="[
                'CANDIDATURAS',
                'visualizar_menu_candidaturas',
                'aprovar_rejeitar_candidatos'
              ]"
            >
              <img src="icons/image-user-down.svg" alt="Candidaturas Icon" />
              Candidaturas
            </li>
            <li
              routerLink="bolsa-profissionais/empresas"
              routerLinkActive="active"
              *appHasAnyRole="[
                'EMPRESAS DO SECTOR',
                'visualizar_menu_empresas_sector',
                'registar_empresa_sector',
                'actualizar_empresa_sector'
              ]"
            >
              <img src="icons/dataflow-03.svg" alt="Empresas Icon" />
              Empresas do Sector
            </li>
          </ul>

          <!-- GESTÃO DE FORMAÇÕES -->
          <li
            class="text-separator"
            (click)="toggleSubmenu('showSubmenuTwo')"
            *appHasAnyRole="[
              'GESTÃO DE FORMAÇÕES',
              'INSTITUIÇÕES DE ENSINO',
              'ESTUDANTES',
              'CURSOS',
              'AUXÍLIOS DE FORMAÇÃO',
              'ACORDOS DE FORMAÇÃO',
              'EMPRESAS GESTORAS',
              'GESTÃO DOCUMENTAL',
              'SOLICITAÇÕES',
              'visualizar_menu_instituições_ensino',
              'visualizar_menu_estudante',
              'visualizar_menu_cursos',
              'visualizar_menu_gestão_documental',
              'visualizar_menu_empresa_gestora'
            ]"
          >
            GESTÃO DE FORMAÇÕES
            <i
              class="pi pi-angle-down"
              [ngClass]="{ rotate: submenus.showSubmenuTwo }"
            ></i>
          </li>
          <ul class="submenu" [ngClass]="{ open: submenus.showSubmenuTwo }">
            <li
              routerLink="gestao-bolseiros/instituicao-ensino"
              routerLinkActive="active"
              *appHasAnyRole="[
                'INSTITUIÇÕES DE ENSINO',
                'visualizar_menu_instituições_ensino',
                'registar_instituições_ensino',
                'actualizar_instituições_ensino'
              ]"
            >
              <img src="icons/building-05.svg" alt="Instituições Icon" />
              Instituições de Ensino
            </li>
            <li
              routerLink="gestao-bolseiros/bolseiros"
              routerLinkActive="active"
              *appHasAnyRole="[
                'ESTUDANTES',
                'visualizar_menu_estudante',
                'registar_estudante',
                'actualizar_registo_estudante',
                'desactivar_estudante'
              ]"
            >
              <img src="icons/graduation-grey.svg" alt="Estudantes Icon" />
              Estudantes
            </li>
            <li
              routerLink="gestao-bolseiros/cursos"
              routerLinkActive="active"
              *appHasAnyRole="[
                'CURSOS',
                'visualizar_menu_cursos',
                'registar_cursos',
                'actualizar_cursos'
              ]"
            >
              <img src="icons/award-01.svg" alt="building Icon" />
              Cursos
            </li>
            <li
              routerLink="gestao-bolseiros/auxilio-formacao"
              routerLinkActive="active"
              *appHasAnyRole="[
                'AUXÍLIOS DE FORMAÇÃO',
                'registar_auxílio_formação',
                'actualizar_auxílio_formação'
              ]"
            >
              <img src="icons/file-05.svg" alt="Auxílios Icon" />
              Auxílios de Formação
            </li>
            <li
              routerLink="gestao-bolseiros/programa-formacao"
              routerLinkActive="active"
              *appHasAnyRole="[
                'ACORDOS DE FORMAÇÃO',
                'visualizar_menu_acordo_formação',
                'registar_acordo_formação',
                'actualizar_acordo_formação'
              ]"
            >
              <img src="icons/certificate-01.svg" alt="Programa Icon" />
              Acordos de Formação
            </li>
            <li
              routerLink="gestao-bolseiros/empresa-gestora"
              routerLinkActive="active"
              *appHasAnyRole="[
                'EMPRESAS GESTORAS',
                'visualizar_menu_empresa_gestora',
                'registar_empresa_gestora',
                'actualizar_empresa_gestora'
              ]"
            >
              <img src="icons/building-03.svg" alt="Empresas Icon" />
              Empresas Gestoras
            </li>
            <li
              routerLink="gestao-bolseiros/emissao-documentos"
              routerLinkActive="active"
              *appHasAnyRole="[
                'GESTÃO DOCUMENTAL',
                'visualizar_menu_gestão_documental',
                'emitir_documentos'
              ]"
            >
              <img src="icons/book-closed2.svg" alt="building Icon" />
              Gestão Documental
            </li>
            <li
              routerLink="gestao-bolseiros/renovacao"
              routerLinkActive="active"
              *appHasAnyRole="['SOLICITAÇÕES']"
            >
              <img src="icons/certificate-01.svg" alt="Programa Icon" />
              Solicitações
            </li>
          </ul>

          <!-- GESTÃO DE CONCURSOS (não há roles específicos na tua lista; mantém admin) -->
          <li
            class="text-separator"
            (click)="toggleSubmenu('showSubmenuThree')"
            *appHasAnyRole="['admin_mirempet']"
          >
            GESTÃO DE CONCURSOS
            <i
              class="pi pi-angle-down"
              [ngClass]="{ rotate: submenus.showSubmenuThree }"
            ></i>
          </li>
          <ul class="submenu" [ngClass]="{ open: submenus.showSubmenuThree }">
            <li
              [routerLink]="['/gestao-concurso/concurso']"
              routerLinkActive="active"
              *appHasAnyRole="['admin_mirempet']"
            >
              <i class="pi pi-trophy"></i>
              Concursos
            </li>
            <li
              [routerLink]="['/gestao-concurso/candidaturas']"
              routerLinkActive="active"
              *appHasAnyRole="['admin_mirempet']"
            >
              <i class="pi pi-clipboard"></i>
              Candidaturas
            </li>
            <li
              [routerLink]="['/gestao-concurso/candidatos']"
              routerLinkActive="active"
              *appHasAnyRole="['admin_mirempet']"
            >
              <i class="pi pi-users"></i>
              Candidatos
            </li>
            <li
              [routerLink]="['/gestao-concurso/comissoes']"
              routerLinkActive="active"
              *appHasAnyRole="['admin_mirempet']"
            >
              <i class="pi pi-sitemap"></i>
              Comissões e júris
            </li>
            <li
              [routerLink]="['/gestao-concurso/provas']"
              routerLinkActive="active"
              *appHasAnyRole="['admin_mirempet']"
            >
              <i class="pi pi-file-edit"></i>
              Provas
            </li>
            <li
              [routerLink]="['/gestao-concurso/apuramento']"
              routerLinkActive="active"
              *appHasAnyRole="['admin_mirempet']"
            >
              <i class="pi pi-chart-bar"></i>
              Apuramento
            </li>
            <li
              [routerLink]="['/gestao-concurso/reclamacoes']"
              routerLinkActive="active"
              *appHasAnyRole="['admin_mirempet']"
            >
              <i class="pi pi-comments"></i>
              Reclamações
            </li>
            <li
              [routerLink]="['/gestao-concurso/auditoria']"
              routerLinkActive="active"
              *appHasAnyRole="['admin_mirempet']"
            >
              <i class="pi pi-history"></i>
              Auditoria
            </li>
            <li
              [routerLink]="['/gestao-concurso/catalogos']"
              routerLinkActive="active"
              *appHasAnyRole="['admin_mirempet']"
            >
              <i class="pi pi-cog"></i>
              Catálogos
            </li>
          </ul>

          <!-- CONFIGURAÇÕES -->
          <li
            class="text-separator"
            (click)="toggleSubmenu('showSubmenuFour')"
            *appHasAnyRole="['CONFIGURAÇÕES', 'CONTROLE DE ACESSO', 'GRUPOS', 'PERÍODO DE RENOVAÇÃO']"
          >
            Configurações
            <i
              class="pi pi-angle-down"
              [ngClass]="{ rotate: submenus.showSubmenuFour }"
            ></i>
          </li>
          <ul class="submenu" [ngClass]="{ open: submenus.showSubmenuFour }">
            <li
              routerLink="configuracoes/controle-acesso"
              routerLinkActive="active"
              *appHasAnyRole="['CONTROLE DE ACESSO']"
            >
              <i class="pi pi-lock"></i>
              &nbsp;&nbsp; Utilizadores
            </li>
            <li
              routerLink="configuracoes/perfil"
              routerLinkActive="active"
              *appHasAnyRole="['GRUPOS']"
            >
              <i class="pi pi-user"></i>
              &nbsp;&nbsp; Grupos
            </li>
            <li
              routerLink="configuracoes/registos"
              routerLinkActive="active"
              *appHasAnyRole="['GRUPOS']"
            >
              <i class="pi pi-address-book"></i>
              &nbsp;&nbsp; Registos
            </li>
            <li
              routerLink="configuracoes/periodo-renovacao"
              routerLinkActive="active"
              *appHasAnyRole="['CONFIGURAÇÕES', 'PERÍODO DE RENOVAÇÃO']"
            >
              <i class="pi pi-calendar"></i>
              &nbsp;&nbsp; Período de Renovação
            </li>
          </ul>
        </ul>
      </nav>
    </div>
  </aside>
</div>
